(function(){"use strict";function onElement(selector,callback,options){options=options||{};var root=options.root||document.body,timeout=options.timeout||15e3,existing=document.querySelector(selector);if(existing){callback(existing);return}var done=!1,observer=new MutationObserver(function(){var el=document.querySelector(selector);el&&(done=!0,observer.disconnect(),callback(el))});observer.observe(root,{childList:!0,subtree:!0}),setTimeout(function(){done||observer.disconnect()},timeout)}function ready(fn){document.readyState==="loading"?document.addEventListener("DOMContentLoaded",fn):fn()}ready(function(){window.innerWidth>=767||document.querySelectorAll("footer .footer-block__heading").forEach(function(heading){heading.addEventListener("click",function(){var content=heading.parentElement?heading.parentElement.querySelector(".footer-block__details-content"):null;content&&content.classList.toggle("footer-block__details-content--open")})})}),(function(){var bar=document.querySelector(".utillity-bar-main");if(!bar)return;var ticking=!1;function update(){window.pageYOffset>8?bar.classList.add("open"):bar.classList.remove("open"),ticking=!1}window.addEventListener("scroll",function(){ticking||(ticking=!0,window.requestAnimationFrame(update))},{passive:!0}),update()})(),(function(){var details=document.getElementById("Details-menu-drawer-container"),chatbot=document.getElementById("react-chatbot-container");!details||!chatbot||details.addEventListener("toggle",function(){chatbot.style.display=details.open?"none":"block"})})(),(function(){function setupScrollSyncForShopBy(containerSelector){var container=document.querySelector(containerSelector);if(!container)return;var shopByDetail=Array.from(container.querySelectorAll("details")).find(function(detail){var summary=detail.querySelector("summary span.left-menu-link");return summary&&summary.textContent.trim()==="Shop By"});if(!shopByDetail)return;var scrollContainer=shopByDetail.querySelector(".third-lvl-hamburger"),leftMenuItems=shopByDetail.querySelectorAll(".collection-summary"),rightSections=Array.from(scrollContainer?scrollContainer.querySelectorAll(".third-lvl-group"):[]);if(!scrollContainer||!rightSections.length||!leftMenuItems.length)return;var sectionMap={};leftMenuItems.forEach(function(item){var id=item.getAttribute("data-scroll-target");id&&(sectionMap[id]=item)});function setActive(id){var target=sectionMap[id];target&&(leftMenuItems.forEach(function(el){el.classList.remove("active-summary")}),target.classList.add("active-summary"))}var activeId="",observer=new IntersectionObserver(function(entries){var best=null;if(entries.forEach(function(entry){var id2=entry.target.getAttribute("id");sectionMap[id2]&&entry.isIntersecting&&(!best||entry.intersectionRatio>best.intersectionRatio)&&(best=entry)}),best){var id=best.target.getAttribute("id");id!==activeId&&(activeId=id,setActive(id))}},{root:scrollContainer,threshold:[.25,.5,.75]});rightSections.forEach(function(section){observer.observe(section)}),leftMenuItems.forEach(function(item){item.addEventListener("click",function(){var id=item.getAttribute("data-scroll-target"),targetSection=scrollContainer.querySelector("#"+(window.CSS&&CSS.escape?CSS.escape(id):id));targetSection&&(activeId=id,setActive(id),scrollContainer.scrollTo({top:targetSection.offsetTop-scrollContainer.offsetTop,behavior:"smooth"}))})}),leftMenuItems.length&&!shopByDetail.querySelector(".collection-summary.active-summary")&&leftMenuItems[0].classList.add("active-summary")}ready(function(){setupScrollSyncForShopBy("#HeaderDrawerMenu"),setupScrollSyncForShopBy("#StickyMobileMenu")})})(),ready(function(){var done=!1,observer=new MutationObserver(function(){var widget=document.querySelector(".jdgm-rev-widg"),header=widget?widget.querySelector(".jdgm-rev-widg__header"):null;if(!(!widget||!header)){var selectors=[".jdgm-row-actions",".jdgm-rev-widg__body",".jdgm-rev-widg__paginate-spinner-wrapper"],targets=selectors.map(function(sel){return widget.querySelector(sel)}).filter(Boolean);targets.length===selectors.length&&(targets.forEach(function(el){el.classList.add("jdgm-slide-toggle"),el.classList.remove("active")}),header.style.cursor="pointer",header.addEventListener("click",function(){targets.forEach(function(el){el.classList.toggle("active")})}),done=!0,observer.disconnect())}});observer.observe(document.body,{childList:!0,subtree:!0}),setTimeout(function(){done||observer.disconnect()},15e3)}),document.addEventListener("DOMContentLoaded",function(){const checkInterval=setInterval(function(){const writeReviewButton=document.querySelector(".jdgm-write-rev-link");if(writeReviewButton){const seeAllReviewsLink=document.createElement("a");seeAllReviewsLink.href="#reviews",seeAllReviewsLink.textContent="See All Reviews",seeAllReviewsLink.className="see-all-reviews-link",seeAllReviewsLink.style.display="block",seeAllReviewsLink.style.marginTop="10px",seeAllReviewsLink.style.color="#ec1a23",seeAllReviewsLink.style.textDecoration="none",writeReviewButton.parentElement.appendChild(seeAllReviewsLink),clearInterval(checkInterval)}},500)}),ready(function(){var menuDrawer=document.getElementById("Details-menu-drawer-container"),cartDrawer=document.querySelector("cart-drawer"),chatWidget=document.getElementById("chat-widget"),hamburgerMenu=document.querySelector(".hamburger-coll");if(!chatWidget)return;function toggleChatWidget(){var isMenuOpen=menuDrawer&&menuDrawer.classList.contains("menu-opening")&&menuDrawer.hasAttribute("open")||hamburgerMenu&&hamburgerMenu.classList.contains("active")&&hamburgerMenu.style.display!=="none",isCartOpen=cartDrawer&&cartDrawer.classList.contains("active");chatWidget.style.display=isMenuOpen||isCartOpen?"none":"block"}menuDrawer&&new MutationObserver(toggleChatWidget).observe(menuDrawer,{attributes:!0,attributeFilter:["class","open"]}),cartDrawer&&new MutationObserver(toggleChatWidget).observe(cartDrawer,{attributes:!0,attributeFilter:["class"]}),hamburgerMenu&&new MutationObserver(toggleChatWidget).observe(hamburgerMenu,{attributes:!0,attributeFilter:["class","style"]}),toggleChatWidget()}),(function(){function place(el){el.style.setProperty("top","auto","important"),el.style.setProperty("bottom","68px","important"),el.style.setProperty("right","24px","important")}function applyIfMobile(){if(!(window.innerWidth>767)){var el=document.querySelector(".snize-sticky-searchbox.bottom-right");el&&place(el)}}ready(function(){onElement(".snize-sticky-searchbox.bottom-right",function(){applyIfMobile()});var rT;window.addEventListener("resize",function(){clearTimeout(rT),rT=setTimeout(applyIfMobile,150)},{passive:!0})})})(),(function(){var CSS_ID="hide-snize-btn-css";function addHideCSS(){if(!document.getElementById(CSS_ID)){var s=document.createElement("style");s.id=CSS_ID,s.innerHTML=".snize-sticky-searchbox,a.snize-sticky-searchbox,.snize-sticky-searchbox__icon{display:none !important;visibility:hidden !important;}",document.head.appendChild(s)}}function removeHideCSS(){var css=document.getElementById(CSS_ID);css&&css.remove()}function updateVisibility(){var isSearch=location.pathname.indexOf("/search")!==-1||location.search.indexOf("q=")!==-1;isSearch?addHideCSS():removeHideCSS()}["pushState","replaceState"].forEach(function(type){var orig=history[type];typeof orig=="function"&&(history[type]=function(){var r=orig.apply(this,arguments);return updateVisibility(),r})}),window.addEventListener("popstate",updateVisibility),ready(updateVisibility)})(),(function(){var searchInput=document.querySelector(".search__input"),searchButton=document.querySelector(".search__button");if(!searchInput||!searchButton)return;function toggleSearchButton(){searchInput.value.trim()===""?searchButton.setAttribute("disabled","true"):searchButton.removeAttribute("disabled")}searchInput.addEventListener("input",toggleSearchButton),toggleSearchButton()})(),(function(){if(location.pathname.indexOf("/collections/new-arrival")===-1)return;function applySortFix(select){var featuredOption=select.querySelector('option[value="manual"]');featuredOption&&featuredOption.remove();var url=new URL(window.location.href),currentSort=url.searchParams.get("sort_by");if(!currentSort){url.searchParams.set("sort_by","created-descending"),window.location.replace(url.toString());return}select.value!=="created-descending"&&currentSort==="created-descending"&&(select.value="created-descending")}onElement("#SortBy",applySortFix)})(),ready(function(){var videos=document.querySelectorAll(".video-element");if(videos.length){var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){var video=entry.target;entry.isIntersecting?video.play().catch(function(){}):video.pause()})},{threshold:.5});videos.forEach(function(video){video.muted=!0,observer.observe(video)})}})})(),(function(){const HIDDEN="gbbExtProductCardPrice--hidden";function unhide(root=document){root.querySelectorAll("."+HIDDEN).forEach(el=>{el.classList.remove(HIDDEN),el.style.setProperty("visibility","visible","important"),el.style.setProperty("display","","important"),el.style.setProperty("opacity","1","important")})}unhide(),new MutationObserver(muts=>{for(const m of muts)m.type==="attributes"&&m.target.classList.contains(HIDDEN)&&unhide(document),m.addedNodes&&m.addedNodes.forEach(n=>{n.nodeType===1&&unhide(n)})}).observe(document.documentElement,{subtree:!0,childList:!0,attributes:!0,attributeFilter:["class"]}),console.log("[unhide] active")})();
(function () {
  if (window.__deodapWhatmoreDetailsEnhancer) return;
  window.__deodapWhatmoreDetailsEnhancer = true;

  var state = {
    sourceCache: {},
    eventCache: {},
    productCache: {},
    observer: null,
    timer: null
  };

  var TILE_SELECTOR = '.whatmore-event-tile-horizontal-swipe-animation-next';
  var HIDDEN_CLASS = 'deodap-whatmore-hidden-reel';
  var READY_CLASS = 'deodap-whatmore-ready-reel';

  function text(value) {
    return String(value == null ? '' : value).trim();
  }

  function formatMoney(value) {
    if (value == null || value === '') return '';
    var number = Number(value);
    if (!Number.isFinite(number)) return '';
    if (number > 9999) number = number / 100;
    return '\u20b9 ' + Math.round(number);
  }

  function discountPercent(price, comparePrice) {
    var current = Number(price);
    var compare = Number(comparePrice);
    if (!Number.isFinite(current) || !Number.isFinite(compare) || compare <= current || compare <= 0) return '';
    return Math.round(((compare - current) / compare) * 100) + '% off';
  }

  function getDataWh(root, selector) {
    var node = root && root.querySelector ? root.querySelector(selector + '[data-wh]') : null;
    if (!node) node = document.querySelector(selector + '[data-wh]');
    return node ? text(node.getAttribute('data-wh')) : '';
  }

  function getWhatmoreIds(root) {
    return {
      shopId: getDataWh(root, '#whatmoreShopId'),
      collectionId: getDataWh(root, '#whatmoreCollectionId'),
      pageId: getDataWh(root, '#whatmorePageId'),
      extensionType: getDataWh(root, '#whatmoreExtensionType')
    };
  }

  function productHandleFromLink(link) {
    try {
      var url = new URL(link, window.location.origin);
      var match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? match[1] : '';
    } catch (error) {
      return '';
    }
  }

  function eventIdFromTile(tile) {
    var playable = tile.querySelector('[aria-label^="Play video:"]');
    var label = playable ? playable.getAttribute('aria-label') : '';
    var match = label && label.match(/(\d+)/);
    return match ? match[1] : '';
  }

  function fetchJson(url) {
    var options = url.charAt(0) === '/' ? { credentials: 'same-origin' } : { credentials: 'omit' };
    return fetch(url, options).then(function (response) {
      if (!response.ok) throw new Error('Request failed: ' + response.status);
      return response.json();
    });
  }

  function eventArrayFromData(data) {
    if (Array.isArray(data)) return data;
    if (!data || typeof data !== 'object') return [];
    if (Array.isArray(data.events)) {
      var flattened = [];

      data.events.forEach(function (group) {
        if (group && Array.isArray(group.events)) {
          flattened = flattened.concat(group.events);
        } else if (group && (group.event_id || group.id)) {
          flattened.push(group);
        }
      });

      return flattened;
    }

    return data.event_id || data.id ? [data] : [];
  }

  function buildEventMap(data) {
    var map = {};
    eventArrayFromData(data).forEach(function (event) {
      var id = event && (event.event_id || event.id);
      if (id != null) map[String(id)] = event;
    });
    return map;
  }

  function sourceKey(ids) {
    if (!ids.shopId) return '';
    if (ids.collectionId && ids.collectionId !== '0') return 'collection:' + ids.shopId + ':' + ids.collectionId;
    if (ids.extensionType === 'index' || ids.collectionId === '0') return 'homepage:' + ids.shopId;
    return '';
  }

  function getSourceMap(root) {
    var ids = getWhatmoreIds(root);
    var key = sourceKey(ids);
    if (!key) return Promise.resolve({});
    if (state.sourceCache[key]) return state.sourceCache[key];

    var url = '';
    if (key.indexOf('collection:') === 0) {
      url = 'https://consumer.whatmore.live/v4/collection?store_id=' + encodeURIComponent(ids.shopId) + '&client_collection_id=' + encodeURIComponent(ids.collectionId);
    } else if (key.indexOf('homepage:') === 0) {
      url = 'https://api.whatmore.live/brands/' + encodeURIComponent(ids.shopId) + '/events/homepage?shuffle_type=recent';
    }

    if (!url) return Promise.resolve({});

    state.sourceCache[key] = fetchJson(url).then(buildEventMap).catch(function (error) {
      delete state.sourceCache[key];
      throw error;
    });

    return state.sourceCache[key];
  }

  function getEventById(eventId) {
    if (!eventId) return Promise.resolve(null);
    if (state.eventCache[eventId]) return state.eventCache[eventId];

    state.eventCache[eventId] = fetchJson('https://api.whatmore.live/event/' + encodeURIComponent(eventId)).then(function (data) {
      return eventArrayFromData(data)[0] || null;
    }).catch(function (error) {
      delete state.eventCache[eventId];
      throw error;
    });

    return state.eventCache[eventId];
  }

  function getEventForTile(tile, eventId) {
    var root = tile.closest('.whatmore-base') || document;
    return getSourceMap(root).then(function (map) {
      return map[eventId] || getEventById(eventId);
    }).catch(function () {
      return getEventById(eventId).catch(function () {
        return null;
      });
    });
  }

  function productList(event) {
    return event && Array.isArray(event.products) ? event.products : [];
  }

  function productIsDraft(product) {
    var status = text(product.product_status || product.status || product.product_state).toLowerCase();
    return status === 'draft' || status === 'archived' || status === 'inactive' || status === 'deleted';
  }

  function productIsOutOfStock(product) {
    var status = text(product.product_status || product.status || product.stock_status).toLowerCase();
    return product.in_stock === false ||
      product.available === false ||
      product.available_for_sale === false ||
      status === 'out_of_stock' ||
      status === 'oos';
  }

  function whatmoreProductToApiProduct(product) {
    if (!product) return null;
    var link = product.product_link || product.link || product.url || '';
    var handle = productHandleFromLink(link);
    if (!handle) return null;

    return {
      handle: handle,
      title: text(product.title || product.product_title),
      price: product.price || product.sale_price || product.current_price,
      comparePrice: product.compare_price || product.compare_at_price || product.mrp,
      productLink: link
    };
  }

  function saleableApiProductFromEvent(event) {
    var products = productList(event);

    for (var i = 0; i < products.length; i += 1) {
      if (!productIsDraft(products[i]) && !productIsOutOfStock(products[i])) {
        var apiProduct = whatmoreProductToApiProduct(products[i]);
        if (apiProduct) return apiProduct;
      }
    }

    return null;
  }

  function shouldHideEvent(event) {
    if (!event || typeof event !== 'object') return false;
    if (event.in_stock === false || event.available === false) return true;

    var products = productList(event);
    if (!products.length) return true;

    return !saleableApiProductFromEvent(event);
  }

  function getProductByHandle(handle) {
    if (!handle) return Promise.resolve(null);
    if (Object.prototype.hasOwnProperty.call(state.productCache, handle)) return Promise.resolve(state.productCache[handle]);

    return fetchJson('/products/' + encodeURIComponent(handle) + '.js').then(function (product) {
      var variants = Array.isArray(product.variants) ? product.variants : [];
      var variant = variants.length ? variants[0] : {};
      var hasAvailableVariant = variants.length ? variants.some(function (item) {
        return item && item.available !== false;
      }) : product.available !== false;
      var result = {
        sku: text(variant.sku),
        price: product.price || variant.price,
        comparePrice: product.compare_at_price || variant.compare_at_price,
        title: text(product.title),
        available: product.available !== false && hasAvailableVariant
      };

      state.productCache[handle] = result;
      return result;
    }).catch(function () {
      state.productCache[handle] = null;
      return null;
    });
  }

  function hideTile(tile, reason) {
    tile.classList.add(HIDDEN_CLASS);
    tile.classList.remove(READY_CLASS);
    tile.setAttribute('aria-hidden', 'true');
    tile.setAttribute('data-deodap-whatmore-hidden-reason', reason || 'unavailable-product');

    tile.querySelectorAll('video').forEach(function (video) {
      try {
        video.pause();
      } catch (error) {}
    });
  }

  function showTile(tile) {
    tile.classList.add(READY_CLASS);
    tile.classList.remove(HIDDEN_CLASS);
    tile.removeAttribute('aria-hidden');
    tile.removeAttribute('data-deodap-whatmore-hidden-reason');
  }

  function hasVisiblePrice(info) {
    return /\u20b9\s*\d+/.test(info.textContent || '');
  }

  function insertDetails(info, product, apiProduct) {
    if (!info || !product) return;

    var existing = info.querySelector('.deodap-whatmore-details');
    if (existing) existing.remove();

    var sku = text(product.sku);
    if (!sku) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'deodap-whatmore-details';

    var skuRow = document.createElement('div');
    skuRow.className = 'deodap-whatmore-sku';
    skuRow.textContent = 'SKU: ' + sku;
    wrapper.appendChild(skuRow);

    if (!hasVisiblePrice(info)) {
      var price = apiProduct.price || product.price;
      var comparePrice = apiProduct.comparePrice || product.comparePrice;
      var priceText = formatMoney(price);
      var compareText = formatMoney(comparePrice);
      var discountText = discountPercent(price, comparePrice);

      if (priceText) {
        var priceRow = document.createElement('div');
        priceRow.className = 'deodap-whatmore-price';
        priceRow.textContent = priceText;

        if (compareText) {
          var compare = document.createElement('span');
          compare.className = 'deodap-whatmore-compare';
          compare.textContent = compareText;
          priceRow.appendChild(compare);
        }

        if (discountText) {
          var discount = document.createElement('span');
          discount.className = 'deodap-whatmore-discount';
          discount.textContent = discountText;
          priceRow.appendChild(discount);
        }

        wrapper.appendChild(priceRow);
      }
    }

    var paragraphs = Array.prototype.slice.call(info.querySelectorAll('p'));
    var titleElement = paragraphs.find(function (item) {
      var itemText = text(item.textContent);
      return itemText && itemText.indexOf('\u20b9') === -1 && itemText.indexOf('%') === -1;
    });

    if (titleElement) {
      titleElement.insertAdjacentElement('afterend', wrapper);
    } else {
      info.insertAdjacentElement('afterbegin', wrapper);
    }
  }

  function enhance() {
    var tiles = document.querySelectorAll(TILE_SELECTOR);

    return Promise.all(Array.prototype.map.call(tiles, function (tile) {
      var eventId = eventIdFromTile(tile);
      if (!eventId) {
        showTile(tile);
        return Promise.resolve();
      }

      return getEventForTile(tile, eventId).then(function (event) {
        if (!event) {
          showTile(tile);
          return;
        }

        if (shouldHideEvent(event)) {
          hideTile(tile, 'draft-or-out-of-stock');
          return;
        }

        var apiProduct = saleableApiProductFromEvent(event);
        if (!apiProduct || !apiProduct.handle) return;

        return getProductByHandle(apiProduct.handle).then(function (product) {
          if (!product || product.available === false) {
            hideTile(tile, 'unpublished-or-no-stock');
            return;
          }

          showTile(tile);

          var info = tile.querySelector('.wht-prod-info');
          if (!info || info.querySelector('.deodap-whatmore-details')) return;
          insertDetails(info, product, apiProduct);
        });
      });
    })).catch(function (error) {
      if (window.console && window.console.debug) window.console.debug('[deodap-whatmore-details]', error);
    });
  }

  function schedule() {
    window.clearTimeout(state.timer);
    state.timer = window.setTimeout(enhance, 250);
  }

  function observe() {
    if (state.observer) return;

    state.observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          schedule();
          return;
        }
      }
    });

    state.observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  observe();
  schedule();
  window.setTimeout(schedule, 2000);
  window.setTimeout(schedule, 7000);
})();
//# sourceMappingURL=/cdn/shop/t/584/assets/general-script.js.map?v=139974377155382090831783001531



